import React from "react";
import CareerHero from "./CareerHero";
import WhyJoinUsCareer from "./WhyJoinUsCareer";
import OpenPositions from "./OpenPositions";
import CareerLife from "./CareerLife";
const Career = () => {
  return (
    <div className="career-page">
      <CareerHero />
      <WhyJoinUsCareer />
      <OpenPositions />
      <CareerLife />
      {}
    </div>
  );
};

export default Career;
